import FadeIn from "@/components/FadeIn";
import { IMG } from "@/data/images";

const VALUES = [
  { icon: "🎯", title: "Seriozitate", desc: "Respectăm fiecare angajament asumat față de client, indiferent de context." },
  { icon: "🏗️", title: "Calitate", desc: "Folosim exclusiv materiale certificate și tehnici de construcție moderne." },
  { icon: "⏱️", title: "Punctualitate", desc: "Termenele contractuale sunt pentru noi obligații, nu estimări." },
  { icon: "🤝", title: "Transparență", desc: "Clientul știe în permanență stadiul lucrărilor și situația bugetului." },
];

const TEAM = [
  {
    name: "Ing. Alexandru Popa",
    role: "Fondator & Director General",
    img: IMG.team[0],
    bio: "Cu o diplomă de inginer constructor de la TUIASI și 20 de ani pe șantier, Alexandru coordonează strategia și relațiile cu clienții majori.",
  },
  {
    name: "Ing. Cristina Lazăr",
    role: "Director Tehnic",
    img: IMG.team[1],
    bio: "Responsabilă de calitatea execuției pe toate șantierele active, Cristina verifică personal fiecare fază critică a construcției.",
  },
  {
    name: "Ec. Bogdan Munteanu",
    role: "Director Financiar",
    img: IMG.team[2],
    bio: "Garantează transparența costurilor și respectarea bugetelor agreate cu fiecare client.",
  },
];

const CERTS = [
  { icon: "📋", title: "Autorizație Constructor Gr. I", sub: "MLPDA" },
  { icon: "🏆", title: "ISO 9001:2015", sub: "Managementul Calității" },
  { icon: "🛡️", title: "ISO 45001", sub: "Securitate și Sănătate în Muncă" },
  { icon: "🌿", title: "ISO 14001", sub: "Management de Mediu" },
];

export default function Despre() {
  return (
    <div data-testid="despre-page">
      <header className="sb-page-header">
        <div className="sb-container">
          <h1>Despre Noi</h1>
          <p>15 ani de construcții rezidențiale în Moldova</p>
        </div>
      </header>

      {/* Story */}
      <section className="sb-section">
        <div className="sb-container">
          <div className="sb-about-grid">
            <FadeIn className="sb-about-image">
              <img
                src={IMG.aboutStory}
                alt="Echipa StructBuild Construct pe un șantier din Iași"
                className="sb-img-cover"
                width="700"
                height="500"
                loading="lazy"
              />
            </FadeIn>
            <FadeIn className="sb-about-content" delay={120}>
              <div className="sb-uppercase-label">POVESTEA NOASTRĂ</div>
              <h2>De la Fundație la Excelență</h2>
              <p>
                StructBuild Construct a fost fondată în 2009 de ing. Alexandru Popa, cu o viziune
                clară: să ofere locuitorilor din Moldova case construite cu seriozitate, la
                standarde ridicate și prețuri corecte.
              </p>
              <p>
                În cei peste 15 ani de activitate, am crescut de la o echipă de 5 oameni la o firmă
                cu 35 de specialiști — ingineri, arhitecți, maiștri și muncitori calificați — toți
                angajați proprii, fără subcontractori.
              </p>
              <p>
                Astăzi, cu peste 200 de proiecte finalizate în Iași, Pașcani, Roman, Vaslui și
                împrejurimi, StructBuild Construct este unul dintre cei mai apreciați constructori
                rezidențiali din regiunea Moldovei.
              </p>
            </FadeIn>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="sb-section" style={{ background: "var(--sb-bg-light)" }}>
        <div className="sb-container">
          <FadeIn className="sb-section-header">
            <h2 className="sb-section-title">Valorile Noastre</h2>
          </FadeIn>
          <div className="sb-values-grid">
            {VALUES.map((v, i) => (
              <FadeIn key={v.title} delay={i * 90}>
                <div className="sb-value-card" data-testid={`value-card-${i}`}>
                  <div className="sb-value-icon" aria-hidden="true">{v.icon}</div>
                  <h3>{v.title}</h3>
                  <p>{v.desc}</p>
                </div>
              </FadeIn>
            ))}
          </div>
        </div>
      </section>

      {/* Team */}
      <section className="sb-section">
        <div className="sb-container">
          <FadeIn className="sb-section-header">
            <h2 className="sb-section-title">Echipa de Conducere</h2>
          </FadeIn>
          <div className="sb-team-grid">
            {TEAM.map((m, i) => (
              <FadeIn key={m.name} delay={i * 100}>
                <div className="sb-team-card" data-testid={`team-card-${i}`}>
                  <div className="sb-avatar">
                    <img
                      src={m.img}
                      alt={`Portret ${m.name}`}
                      className="sb-img-cover"
                      width="200"
                      height="200"
                      loading="lazy"
                    />
                  </div>
                  <h3>{m.name}</h3>
                  <div className="sb-team-role">{m.role}</div>
                  <p className="sb-team-bio">{m.bio}</p>
                </div>
              </FadeIn>
            ))}
          </div>
        </div>
      </section>

      {/* Certs */}
      <section className="sb-section" style={{ background: "var(--sb-bg-light)" }}>
        <div className="sb-container">
          <FadeIn className="sb-section-header">
            <h2 className="sb-section-title">Autorizații & Certificări</h2>
          </FadeIn>
          <div className="sb-certs-grid">
            {CERTS.map((c, i) => (
              <FadeIn key={c.title} delay={i * 80}>
                <div className="sb-cert-card" data-testid={`cert-card-${i}`}>
                  <div className="sb-cert-icon" aria-hidden="true">{c.icon}</div>
                  <div>
                    {c.title}
                    <div className="sb-cert-sub">{c.sub}</div>
                  </div>
                </div>
              </FadeIn>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
